import { render, staticRenderFns } from "./IconCountry.vue?vue&type=template&id=f4a3986a&"
import script from "./IconCountry.vue?vue&type=script&lang=js&"
export * from "./IconCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports